// Split out of financialStatementExcel so callers that only need the name
// rule don't pull SheetJS into their chunk.
/**
 * Worksheet tab names: ≤31 chars, no []:*?/\, no apostrophe at either end, not
 * "History" (Excel reserves it; SheetJS throws on both).
 */
export const sanitizeSheetName = (name) => {
  const clean = String(name || 'Statement').replace(/[\\/?*[\]:]/g, ' ').substring(0, 31).replace(/^'+|'+$/g, '') || 'Statement';
  return clean.toLowerCase() === 'history' ? `${clean} (2)` : clean;
};
